<!--
 * @Description:
 * @Author: 钱磊
 * @Date: 2022-07-21 14:24:32
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-31 08:49:43
-->
<!--  -->
<!--  -->
<template>
	<div class="h100">
		<div class="h100" v-if="!routeQuery">
			<w-split class="h100" v-model="splitValue">
				<div class="w-page-main left" slot="left">
					<!-- 左侧专家库列表 -->
					<div class="w-page-container pdb10">
						<el-row>
							<el-col :span="19">
								<el-input
									:placeholder="'搜索专家库'"
									clearable
									v-model="sname"
									suffix-icon="el-icon-search"
									@change="getLibList"
									size="small"
								></el-input>
							</el-col>
							<el-col :span="4" :offset="1">
								<el-button type="success" size="small" @click="addExpert">新增</el-button>
							</el-col>
						</el-row>
						<div class="w-table-content mt10">
							<vxe-table
								ref="leftTable"
								:data="tableObj.tableData"
								:loading="tableObj.loading"
								:border="tableObj.border"
								:resizable="tableObj.resizable"
								:size="tableObj.size"
								:height="tableObj.height"
								highlight-current-row
								highlight-hover-row
								show-overflow="tooltip"
								show-header-overflow="tooltip"
								@current-change="onLeftRowClick"
							>
								<vxe-table-column field="sname" title="专家库名称" align="center"></vxe-table-column>
								<vxe-table-column title="归属类型" width="100" align="center">
									<template v-slot="{ row }">
										<p class="belongLib" :class="{ libType: row.libType != '0' }">
											{{ row.libType == '0' ? '企业' : '平台' }}
										</p>
									</template>
								</vxe-table-column>
								<vxe-table-column title="状态" width="70" align="center">
									<template v-slot="{ row }">
										<p :class="{ 'color-failed': row.status == '0' }">
											{{ row.status == '0' ? '关闭' : '启用' }}
										</p>
									</template>
								</vxe-table-column>
								<vxe-table-column field="unitName" title="归属单位" align="center"></vxe-table-column>
							</vxe-table>
						</div>
					</div>
				</div>
				<div class="w-table-layout right" slot="right">
					<div class="tab-main">
						<div class="add-btns mt5" v-show="activeTabs == 'baseInfo' || activeTabs == 'belongUnit' || activeTabs == 'majorType'">
							<el-row>
								<el-button type="primary" size="mini" class="fr ml5" :disabled="!isEdit" :loading="btnLoading" @click="doSave"
									>保存</el-button
								>
								<el-button type="warning" size="mini" class="fr" :disabled="isEdit" @click="modify">修改 </el-button>
							</el-row>
						</div>
						<el-tabs v-model="activeTabs" :before-leave="leaveTab" @tab-click="tabClick" class="full-tabs">
							<el-tab-pane v-for="(item, index) in tabArr" :key="index" :label="item.label" :name="item.name">
								<span slot="label"
									><svg-icon :icon-class="item.iconClass" class="icon-style"></svg-icon>
									{{ item.label }}
								</span>
								<!-- 基本信息 -->
								<div class="tab-box" v-if="activeTabs == 'baseInfo' && index === 0">
									<el-form ref="baseForm" :model="baseForm" :rules="baseRule" label-width="170px">
										<el-row>
											<el-col :span="9">
												<el-form-item label="专家库状态：">
													<el-tooltip
														effect="light"
														popper-class="person-style"
														content="专家库状态关闭后，客户端就不显示此专家库，无法进行专家入库申请，也无法使用专家库"
														placement="top"
													>
														<svg-icon icon-class="tips" class="icon-style mr20"></svg-icon>
													</el-tooltip>
													<vxe-switch
														v-model="baseForm.status"
														open-label="启用"
														:open-value="1"
														close-label="关闭"
														:disabled="!isEdit"
														:close-value="0"
														@change="changeStatus()"
													></vxe-switch>
												</el-form-item>
											</el-col>
											<el-col :span="9">
												<el-form-item label="应用库名称：" required>
													<span>{{ baseForm.sname }}</span>
												</el-form-item>
											</el-col>
										</el-row>
										<el-row>
											<el-col :span="9">
												<el-form-item label="是否接受专家入库申请：">
													<el-tooltip
														effect="light"
														popper-class="person-style"
														content="接受专家入库申请，专家可在客户端或专家评审系统中加入该专家库；反之，不能加入该专家库。"
														placement="top"
													>
														<svg-icon icon-class="tips" class="icon-style mr20"></svg-icon>
													</el-tooltip>
													<vxe-switch
														v-model="baseForm.isAccept"
														open-label="是"
														:open-value="1"
														:disabled="!isEdit"
														close-label="否"
														:close-value="0"
													></vxe-switch>
												</el-form-item>
											</el-col>
											<el-col :span="9">
												<el-form-item label="应用库简称：">
													<span>{{ baseForm.shortName }}</span>
												</el-form-item>
											</el-col>
										</el-row>
										<el-row>
											<el-col :span="9">
												<el-form-item label="是否在客户端展示：">
													<el-tooltip
														effect="light"
														popper-class="person-style"
														content="1.当专家库状态为开启时，若选择不在客户端展示，客户端就不显示此专家库，专家就无法申请入库，也无法使用该专家库，反之，可以申请入库和使用该专家库2.当专家库状态为关闭时，不论选择是否在客户端展示，客户端仍不展示该专家库，专家无法申请入库，也无法使用该专家库"
														placement="top"
													>
														<svg-icon icon-class="tips" class="icon-style mr20"></svg-icon>
													</el-tooltip>
													<vxe-switch
														v-model="baseForm.isShow"
														open-label="是"
														:open-value="1"
														:disabled="!isEdit"
														close-label="否"
														:close-value="0"
													></vxe-switch>
												</el-form-item>
											</el-col>
											<el-col :span="9">
												<el-form-item label="专家库归属：" required>
													<span>{{ baseForm.libType == '0' ? '企业专家库' : '平台专家库' }}</span>
												</el-form-item>
											</el-col>
										</el-row>
										<el-row>
											<el-col :span="10" :offset="9">
												<el-form-item label="专家库用途：" required prop="libApply">
													<el-select
														v-model="baseForm.libApply"
														multiple
														placeholder="请选择"
														:disabled="!isEdit"
														size="small"
													>
														<el-option v-for="item in zjkyt" :key="item.value" :label="item.sname" :value="item.value">
														</el-option>
													</el-select>
												</el-form-item>
											</el-col>
										</el-row>
										<el-row>
											<el-col :span="23" class="mt10">
												<el-form-item label="库备注说明：">
													<wang-editor v-model="baseForm.remark" ref="wangEditor1" :height="300" :isViewMode="!isEdit" :max-length="200"></wang-editor>
												</el-form-item>
											</el-col>
										</el-row>
										<el-row>
											<el-col :span="23">
												<el-form-item label="库对外开放说明：" required>
													<wang-editor v-model="baseForm.openRemark" ref="wangEditor2" :height="300" :isViewMode="!isEdit" :max-length="200"></wang-editor>
												</el-form-item>
											</el-col>
										</el-row>
										<el-row>
											<el-col :span="23">
												<el-form-item label="入库标准：" required>
													<wang-editor v-model="baseForm.applyStandard" ref="wangEditor3" :height="300" :isViewMode="!isEdit" :max-length="1000"></wang-editor>
												</el-form-item>
											</el-col>
										</el-row>
									</el-form>
								</div>
								<!-- 专家列表 -->
								<template v-if="activeTabs == 'expertList' && index === 1">
									<expert-list
										ref="expertList"
										:leftRowId="leftRowId"
										@setId="setId"
										@handleChange="handleChange"
										:libId="leftRowId"
									></expert-list>
								</template>
								<!-- 归属单位维护 -->
								<div class="tab-box" v-if="activeTabs == 'belongUnit' && index === 2">
									<div class="belong_unit">
										<div class="unit_label">
											<span>*</span>归属单位
											<el-tooltip
												effect="light"
												popper-class="person-style"
												content="创建的专家库是属于归属单位的，归属单位有权限审核专家入库申请，管理和维护专家库信息。"
												placement="top"
											>
												<svg-icon icon-class="tips" class="icon-style"></svg-icon>
											</el-tooltip>
										</div>
										<el-button class="add_unit" type="primary" :disabled="!isEdit" size="small" @click="addUnit('belongUnit')"
											>+新增单位</el-button
										>
										<div class="clean"></div>
										<div class="w-table-content mt10">
											<vxe-table
												:data="belongUnit.tableData"
												:loading="belongUnit.loading"
												:border="belongUnit.border"
												:resizable="belongUnit.resizable"
												:size="belongUnit.size"
												:max-height="'170px'"
												highlight-current-row
												highlight-hover-row
												show-overflow="tooltip"
												show-header-overflow="tooltip"
											>
												<vxe-table-column type="seq" title="序号" align="center" width="70"></vxe-table-column>
												<vxe-table-column field="sname" title="单位名称" align="center"></vxe-table-column>
												<vxe-table-column field="creditCode" title="统一社会信用代码" align="center"></vxe-table-column>
												<vxe-table-column field="createDate" title="操作" align="center">
													<template #default="{ rowIndex }">
														<el-button
															type="danger"
															size="small"
															round
															:disabled="!isEdit"
															plain
															class="table-btn"
															@click="handleDelete('belongUnit', rowIndex)"
															icon="el-icon-switch-button"
															>删除
														</el-button>
													</template>
												</vxe-table-column>
											</vxe-table>
										</div>
									</div>
									<div class="manage_unit">
										<div class="unit_label">
											<span>*</span>管理单位
											<el-tooltip
												effect="light"
												popper-class="person-style"
												content="管理单位可修改管理该专家库信息，有权限审核专家入库申请。"
												placement="top"
											>
												<svg-icon icon-class="tips" class="icon-style"></svg-icon>
											</el-tooltip>
										</div>
										<el-button class="add_unit" type="primary" size="small" :disabled="!isEdit" @click="addUnit('manageUnit')"
											>+新增单位</el-button
										>
										<div class="clean"></div>
										<div class="w-table-content mt10">
											<vxe-table
												:data="manageUnit.tableData"
												:loading="manageUnit.loading"
												:border="manageUnit.border"
												:resizable="manageUnit.resizable"
												:size="manageUnit.size"
												:max-height="'170px'"
												highlight-current-row
												highlight-hover-row
												show-overflow="tooltip"
												show-header-overflow="tooltip"
											>
												<vxe-table-column type="seq" title="序号" align="center" width="70"></vxe-table-column>
												<vxe-table-column field="sname" title="单位名称" align="center"></vxe-table-column>
												<vxe-table-column field="creditCode" title="统一社会信用代码" align="center"></vxe-table-column>
												<vxe-table-column field="createDate" title="操作" align="center">
													<template #default="{ rowIndex }">
														<el-button
															type="danger"
															size="small"
															round
															plain
															:disabled="!isEdit"
															class="table-btn"
															@click="handleDelete('manageUnit', rowIndex)"
															icon="el-icon-switch-button"
															>删除
														</el-button>
													</template>
												</vxe-table-column>
											</vxe-table>
										</div>
									</div>
									<div class="open_unit">
										<div class="unit_label">
											<span>*</span>专家库开放使用单位
											<el-tooltip
												effect="light"
												popper-class="person-style"
												content="专家库开放给哪些单位使用，该单位可完成专家抽取操作。"
												placement="top"
											>
												<svg-icon icon-class="tips" class="icon-style mr20"></svg-icon>
											</el-tooltip>
											<el-radio v-model="isOpen" :label="1" :disabled="!isEdit">全部单位</el-radio>
											<el-radio v-model="isOpen" :label="0" :disabled="!isEdit">指定单位</el-radio>
										</div>
										<el-button
											class="add_unit"
											type="primary"
											size="small"
											v-if="isOpen == '0'"
											:disabled="!isEdit"
											@click="addUnit('openUnit')"
											>选择单位</el-button
										>
										<div class="clean"></div>
										<div class="w-table-content mt10" v-if="isOpen == '0'">
											<vxe-table
												:data="openUnit.tableData"
												:loading="openUnit.loading"
												:border="openUnit.border"
												:resizable="openUnit.resizable"
												:size="openUnit.size"
												:max-height="'170px'"
												highlight-current-row
												highlight-hover-row
												show-overflow="tooltip"
												show-header-overflow="tooltip"
											>
												<vxe-table-column type="seq" title="序号" align="center" width="70"></vxe-table-column>
												<vxe-table-column field="sname" title="单位名称" align="center"></vxe-table-column>
												<vxe-table-column field="creditCode" title="统一社会信用代码" align="center"></vxe-table-column>
												<vxe-table-column field="createDate" title="操作" align="center">
													<template #default="{ rowIndex }">
														<el-button
															type="danger"
															size="small"
															round
															plain
															class="table-btn"
															:disabled="!isEdit"
															@click="handleDelete('openUnit', rowIndex)"
															icon="el-icon-switch-button"
															>删除
														</el-button>
													</template>
												</vxe-table-column>
											</vxe-table>
										</div>
									</div>
								</div>
								<!-- 专家专业类别 -->
								<div class="tab-box" v-if="activeTabs == 'majorType' && index === 3">
									<div class="major_header">
										<span>*</span>
										请设置专家专业类别<el-button
											type="primary"
											size="small"
											class="ml20"
											:disabled="!isEdit"
											@click="handleSet(0)"
											>新增分类</el-button
										>
									</div>
									<div class="tree_header mt10">
										<span class="name">标题</span>
										<span class="state">状态</span>
										<span class="operation">操作</span>
									</div>
									<el-tree :data="dataTree" node-key="id" :default-expand-all="false" :expand-on-click-node="false">
										<span class="custom-tree-node" slot-scope="{ node, data }">
											<span class="major_name">{{ data.sname }}</span>

											<span class="major_operation">
												<span class="major_state">
													<vxe-switch
														v-model="data.status"
														open-label="启用"
														:open-value="1"
														close-label="关闭"
														:disabled="!isEdit"
														:close-value="0"
													></vxe-switch>
												</span>
												<el-button
													type="text"
													size="mini"
													@click="append(node, data)"
													:disabled="node.level == '4' || !isEdit"
													:class="{ hide: node.level == '4' ? true : false }"
												>
													添加
												</el-button>
												<span :class="{ hide: node.level == '4' ? true : false }">|</span>
												<el-button type="text" size="mini" :disabled="!isEdit" @click="edit(node, data)">
													修改
												</el-button>
												<span>|</span>
												<el-button
													type="text"
													size="mini"
													:disabled="!isEdit"
													class="color-failed"
													@click="remove(node, data)"
												>
													删除
												</el-button>
											</span>
										</span>
									</el-tree>
								</div>
								<!-- 变更记录 -->
								<div class="tab-box" v-if="activeTabs == 'changeRecord' && index === 4">
									<change-record ref="changeRecord" :libId="leftRowId"></change-record>
								</div>
							</el-tab-pane>
						</el-tabs>
						<!-- 弹窗 -->
						<el-dialog
							:visible.sync="dialogObj.visible"
							:width="dialogObj.width"
							:title="dialogObj.title"
							:fullscreen="dialogObj.fullscreen"
							center
							class="add-dialog"
							:close-on-click-modal="false"
						>
							<!-- 如果是选择单位弹窗 -->
							<template v-if="dialogObj.module === 'select'">
								<div class="info-nav mb20">
									<el-row>
										<el-col :span="2">
											<p class="label">单位名称：</p>
										</el-col>
										<el-col :span="8">
											<el-input :placeholder="'请输入'" clearable v-model="companyName" size="small"></el-input>
										</el-col>
										<el-col :span="3" :offset="1">
											<el-button type="primary" size="small" @click="getLibExpert">搜索</el-button>
										</el-col>
									</el-row>
								</div>

								<!-- 选择列表 -->
								<vxe-table
									ref="selectTable"
									:data="selectTable.tableData"
									:loading="selectTable.loading"
									:border="selectTable.border"
									:resizable="selectTable.resizable"
									:size="selectTable.size"
									:max-height="selectTable.height"
									highlight-current-row
									highlight-hover-row
									@checkbox-change="selectChangeEvent"
									@checkbox-all="selectChangeEvent"
									auto-resize
									show-overflow="tooltip"
									show-header-overflow="tooltip"
								>
									<vxe-table-column type="checkbox" width="60" align="center"></vxe-table-column>
									<vxe-table-column type="seq" title="序号" width="60" align="center"></vxe-table-column>
									<vxe-table-column title="单位类型" width="120" field="flatTypeName" align="center"></vxe-table-column>
									<vxe-table-column field="sname" title="公司名称" align="center"></vxe-table-column>
									<vxe-table-column field="creditCode" title="统一社会信用代码" align="center"></vxe-table-column>
								</vxe-table>
								<div v-if="checkList.length > 0" class="checked-company">
									已选中单位：
									<span v-for="(item, index) of checkList" :key="item.id"
										><i class="el-icon-success"></i>{{ item.sname
										}}<i class="el-icon-circle-close" @click="deleteCompany(item, index)"></i
									></span>
								</div>
							</template>

							<!-- 添加、修改专家专业 -->
							<template v-if="dialogObj.module === 'major'">
								<el-form ref="majorForm" :model="majorForm" size="medium" label-width="100px">
									<el-row>
										<el-col :span="22">
											<el-form-item label="一级分类:" required>
												<el-input
													:placeholder="'请输入'"
													clearable
													v-model="majorForm.label1"
													maxlength="30"
													:disabled="showLevel != '0'"
													size="small"
												></el-input>
											</el-form-item>
										</el-col>
										<el-col :span="22">
											<el-form-item label="二级分类:" v-if="showLevel >= 1" required>
												<el-input
													:placeholder="'请输入'"
													clearable
													v-model="majorForm.label2"
													maxlength="30"
													:disabled="showLevel != '1'"
													size="small"
												></el-input>
											</el-form-item>
										</el-col>
										<el-col :span="22">
											<el-form-item label="三级分类:" v-if="showLevel >= 2" required>
												<el-input
													:placeholder="'请输入'"
													clearable
													v-model="majorForm.label3"
													:disabled="showLevel != '2'"
													maxlength="30"
													size="small"
												></el-input>
											</el-form-item>
										</el-col>
										<el-col :span="22">
											<el-form-item label="四级分类:" v-if="showLevel >= 3" required>
												<el-input
													:placeholder="'请输入'"
													clearable
													v-model="majorForm.label4"
													:disabled="showLevel != '3'"
													maxlength="30"
													size="small"
												></el-input>
											</el-form-item>
										</el-col>
										<el-col :span="22">
											<el-form-item label="创建人：">
												<el-input :placeholder="'请输入'" v-model="majorForm.createUser" size="small" disabled></el-input>
											</el-form-item>
										</el-col>
									</el-row>
								</el-form>
							</template>

							<!-- 添加专家库 -->
							<template v-if="dialogObj.module === 'addExpert'">
								<el-form ref="addExpert" :model="addExpertForm" size="medium" :rules="addRule" label-width="110px">
									<el-row class="mt20">
										<el-col :span="20" :offset="2">
											<el-form-item label="应用库名称：" prop="sname">
												<el-input size="small" v-model="addExpertForm.sname" maxlength="20" clearable></el-input>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row class="mt20">
										<el-col :span="20" :offset="2">
											<el-form-item label="应用库简称：" prop="shortName">
												<el-input size="small" v-model="addExpertForm.shortName" maxlength="20" clearable></el-input>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row class="mt20">
										<el-col :span="20" :offset="2">
											<el-form-item label="应用库类型：" prop="libType">
												<el-select v-model="addExpertForm.libType" placeholder="请选择" clearable size="small">
													<el-option label="平台专家库" value="1"> </el-option>
													<el-option label="企业专家库" value="0"> </el-option>
												</el-select>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row class="mt20">
										<el-col :span="20" :offset="2">
											<el-form-item label="应用库用途：" prop="libApply">
												<el-select v-model="addExpertForm.libApply" multiple placeholder="请选择" clearable size="small">
													<el-option v-for="item in zjkyt" :key="item.value" :label="item.sname" :value="item.value">
													</el-option>
												</el-select>
											</el-form-item>
										</el-col>
									</el-row>
								</el-form>
							</template>

							<!-- 修改专家状态 -->
							<template v-if="dialogObj.module === 'changeState'">
								<el-form ref="changeState" :model="changeForm" size="medium" :rules="changeRule" label-width="110px">
									<el-row class="mt20" v-if="changeForm.status == '0'">
										<el-col :span="20" :offset="2">
											<el-form-item label="选择原因：" prop="changeReason">
												<el-select v-model="changeForm.changeReason" placeholder="请选择" clearable size="small">
													<el-option v-for="item in zjtyyy" :key="item.value" :label="item.sname" :value="item.value">
													</el-option>
												</el-select>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row class="mt20">
										<el-col :span="20" :offset="2">
											<el-form-item label="备注原因：" prop="remark">
												<el-input size="small" v-model="changeForm.remark" maxlength="20" clearable></el-input>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row class="mt20">
										<el-col :span="20" :offset="2">
											<el-form-item label="上传附件：">
												<public-upload
													ref="enclosure"
													:aid="changeForm.changeId"
													width="350px"
													listType="text"
													tableName="expert_status_change"
													assortment="expert_status_change"
													:acceptType="acceptType"
													:maxNum="1"
												></public-upload>
											</el-form-item>
										</el-col>
									</el-row>
								</el-form>
							</template>
							<!-- footer 组件 -->
							<div slot="footer" class="pdb10 text-center">
								<el-button size="small" class="btn" @click="dialogObj.visible = false">取 消 </el-button>
								<el-button type="primary" size="small" class="btn btn-blue" @click="submitForm" :loading="dialogObj.btnLoading"
									>确 定
								</el-button>
							</div>
						</el-dialog>
					</div>
				</div>
			</w-split>
		</div>
		<div v-if="routeQuery == 'check'">
			<expert-detail :expertId="expertId" :libId="leftRowId"></expert-detail>
		</div>
	</div>
</template>

<script>
let id = 1000
import { mapState } from 'vuex'
import ExpertList from './components/expert-list.vue'
import ExpertDetail from '../base-expert/components/expert-detail.vue'
import ChangeRecord from './components/change-record.vue'
import * as API from 'api/modules/expert_gz.js'
import { Snowflake } from 'node-snowflake'
export default {
	components: {
		ExpertList,
		ChangeRecord,
		ExpertDetail
	},
	data() {
		return {
			splitValue: 0.35, //左右表格分配
			sname: '', //专家库名称
			addExpertForm: {
				//添加专家库对象
				sname: '', //应用库名称
				shortName: '', //应用库简称
				libType: '', //应用库类型  0企业专家库  1 平台专家库
				libApply: [] //应用库用途
			},
			addRule: {
				//添加专家库非空验证
				sname: [{ required: true, message: '应用库名称不能为空！', trigger: 'blur' }],
				shortName: [{ required: true, message: '应用库简称不能为空！', trigger: 'blur' }],
				libApply: [{ required: true, message: '请选择应用库用途！', trigger: 'change' }],
				libType: [{ required: true, message: '请选择应用库类型！', trigger: 'change' }]
			},
			// 表格对象
			tableObj: {
				//左侧表格对象
				tableData: [],
				loading: false,
				border: true,
				resizable: true,
				size: 'small'
			},
			leftRowId: '', //左侧选中行id
			activeTabs: 'baseInfo', //默认打开的tab页
			isEdit: false, //是否可编辑
			btnLoading: false,
			baseForm: {}, //基础信息对象
			baseRule: {
				libApply: [{ required: true, message: '请选择应用库类型！', trigger: 'change' }]
			},
			zjkyt: [], //专家库用途码表
			expertId: '', //查看专家详情id
			companyName: '', //单位名称
			checkList: [], //选中企业的数组
			// 弹窗对象
			dialogObj: {
				visible: false,
				width: '80%',
				title: '选择单位',
				type: 'add',
				fullscreen: false,
				module: 'select',
				btnLoading: false
			},
			belongUnit: {
				tableData: [],
				loading: false,
				border: true,
				resizable: true,
				size: 'small',
				height: '100%'
			}, //归属单位表格对象
			manageUnit: {
				tableData: [],
				loading: false,
				border: true,
				resizable: true,
				size: 'small',
				height: '100%'
			}, //管理单位表格对象
			openUnit: {
				tableData: [],
				loading: false,
				border: true,
				resizable: true,
				size: 'small',
				height: '100%'
			}, //开放单位表格对象
			choiseIds: [], //已添加的企业id
			isOpen: '1', //专家库开放使用单位类型  "0"是指定单位，"1"是所有单位
			selectTable: {
				//弹出框选择公司的表格对象
				tableData: [],
				loading: false,
				border: true,
				resizable: true,
				size: 'small',
				height: '500px'
			},
			majorForm: {
				label1: '', //一级标题
				label2: '', //二级标题
				label3: '', //三级标题
				label4: '', //四级标题
				createUser: '' //创建人
			}, //专家专业form表单
			changeRule: {
				remark: [{ required: true, message: '备注原因不能为空！', trigger: 'blur' }],
				changeReason: [{ required: true, message: '请选择原因！', trigger: 'change' }]
			}, //修改专家状态验证规则
			changeForm: {
				changeReason: '', //变更原因
				changeId: '',
				remark: '', //备注原因
				userId: '', //专家id
				status: 0, //0禁用 1启用
				type: '2', //1修改基础库专家状态 2修改应用库专家状态 3修改应用库状态 4修改专家接受申请状态
				libId: '', //应用库id （type等于2或3时必填）
				createUser: '' //操作人
			}, //修改专家状态form表单
			acceptType: ['PDF', 'PNG', 'JPEG', 'JPG'],
			zjtyyy: [], //专家停用原因
			showLevel: 0, //显示几级专业
			dataTree: [], //专业类别数组
			currentData: {}, //当前选中行的data
			currentNode: {}, //当前选中行的node
			oldTabName: '', //点击tab页前一个展开的tabname
			changeType: false //是否是修改专家库状态
		}
	},

	created() {
		if (this.$getSessionItem('leftRowId')) {
			this.leftRowId = JSON.parse(this.$getSessionItem('leftRowId'))
			// 移除 避免污染
			this.$removeSessionItem('leftRowId')
		}
		if (this.$getSessionItem('activeTabs')) {
			this.activeTabs = JSON.parse(this.$getSessionItem('activeTabs'))
			// 移除 避免污染
			this.$removeSessionItem('activeTabs')
		}
		this.getDictsByParent()
		this.getLibList()
	},

	methods: {
		/***** 左侧专家库信息 *****/
		// 左侧添加专家按钮
		addExpert() {
			this.dialogObj.width = '600px'
			this.dialogObj.title = '新增'
			this.dialogObj.module = 'addExpert'
			this.dialogObj.visible = true
			this.$nextTick(() => {
				this.$refs.addExpert.resetFields()
			})
		},
		// 获取专家库用途码表
		getDictsByParent() {
			API.getDictsByParent({ value: '1011' }).then((res) => {
				this.zjkyt = res.data
			})
		},
		//获取专家库列表
		getLibList() {
			let params = { sname: this.sname }
			this.tableObj.loading = true
			API.getLibList(params)
				.then((res) => {
					this.tableObj.loading = false
					if (res.operationCode === 1) {
						this.tableObj.tableData = res.data
						if (res.data.length > 0) {
							if (this.leftRowId !== '') {
								let _item = res.data.find((x) => x.id === this.leftRowId)
								this.$refs.leftTable.setCurrentRow(_item)
								if (!this.changeType) {
									this.onLeftRowClick({ row: _item })
								}
							} else {
								this.$refs.leftTable.setCurrentRow(res.data[0])
								this.onLeftRowClick({ row: res.data[0] })
							}
						}
					}
				})
				.catch((err) => {
					this.tableObj.loading = false
				})
		},
		//左侧行点击
		onLeftRowClick({ row, oldValue, rowIndex, $rowIndex }) {
			this.oldTabName = ''
			if (this.isEdit) {
				this.$message.error('请先保存当前页面！')
				this.$refs.leftTable.setCurrentRow(oldValue)
				return
			}
			this.leftRowId = row.id
			this.$setSessionItem('leftRowId', JSON.stringify(this.leftRowId))
			this.tabClick('1')
			if (this.activeTabs == 'changeRecord') {
				this.$refs.changeRecord[0].showDetail = false
			}
		},

		//保存专家库
		saveLibInfo(params) {
			this.$refs.addExpert.validate((valid) => {
				if (valid) {
					API.saveLibInfo(params)
						.then((res) => {
							if (res.operationCode == 1) {
								this.$message.success('应用库添加成功！')
								this.dialogObj.visible = false
								this.getLibList()
								setTimeout(() => {
									this.dialogObj.btnLoading = false
								}, 2000)
							} else {
								this.$message.error(res.msg)
								setTimeout(() => {
									this.dialogObj.btnLoading = false
								}, 2000)
							}
						})
						.catch((err) => {
							setTimeout(() => {
								this.dialogObj.btnLoading = false
							}, 2000)
						})
				} else {
					this.$message.warning('请完善必填项信息！')
					setTimeout(() => {
						this.dialogObj.btnLoading = false
					}, 2000)
				}
			})
		},
		//弹出框的确定按钮
		submitForm() {
			switch (this.dialogObj.module) {
				case 'addExpert': //保存专家库
					this.dialogObj.btnLoading = true
					let params = Object.assign({}, this.addExpertForm)
					params.libApply = this.addExpertForm.libApply.join(',')
					params.createUser = this.userInfo.sname
					this.saveLibInfo(params)
					break
				case 'select': //新增单位
					this[this.dialogObj.type].tableData = this[this.dialogObj.type].tableData.concat(this.checkList)
					this.dialogObj.visible = false
					break
				case 'major': //新增\修改专家专业
					if (this.dialogObj.type == 'add') {
						//判断是新增还是修改
						let newChild = {
							id: '',
							pid: '',
							sname: '',
							status: 1,
							children: []
						}
						let _status
						switch (this.showLevel) {
							case 0:
								console.log(this.majorForm.label1)
								if (this.majorForm.label1 != '') {
									_status = true
									newChild.id = Snowflake.nextId()
									newChild.pid = '0'
									newChild.sname = this.majorForm.label1
									this.dataTree.push(newChild)
								} else {
									_status = false
								}
								break
							case 1:
								if (this.majorForm.label2 != '') {
									_status = true
									newChild.id = Snowflake.nextId()
									newChild.pid = this.currentData.id
									newChild.sname = this.majorForm.label2
									this.currentData.children.push(newChild)
								} else {
									_status = false
								}
								break
							case 2:
								if (this.majorForm.label3 != '') {
									_status = true
									newChild.id = Snowflake.nextId()
									newChild.pid = this.currentData.id
									newChild.sname = this.majorForm.label3
									this.currentData.children.push(newChild)
								} else {
									_status = false
								}
								break
							case 3:
								if (this.majorForm.label4 != '') {
									_status = true
									newChild.id = Snowflake.nextId()
									newChild.pid = this.currentData.id
									newChild.sname = this.majorForm.label4
									this.currentData.children.push(newChild)
								} else {
									_status = false
								}
								break
						}
						if (_status) {
							this.dialogObj.visible = false
						} else {
							this.$message.error('请完善表单!')
						}
					} else {
						switch (this.showLevel) {
							case 0:
								this.currentNode.data.sname = this.majorForm.label1
								break
							case 1:
								this.currentNode.data.sname = this.majorForm.label2
								break
							case 2:
								this.currentNode.data.sname = this.majorForm.label3
								break
							case 3:
								this.currentNode.data.sname = this.majorForm.label4
								break
						}
						this.dialogObj.visible = false
					}
					break
				case 'changeState': //修改专家库专家状态
					this.dialogObj.btnLoading = true
					let param = Object.assign({}, this.changeForm)
					this.changeLibExpert(param)
					break
				default:
					break
			}
		},
		leaveTab() {
			if (this.isEdit) {
				this.$message.error('请先保存当前页面！')
				return false
			}
		},
		//tab页点击事件
		tabClick(val) {
			if (this.leftRowId != '' && this.oldTabName != this.activeTabs) {
				this.oldTabName = this.activeTabs
				this.$setSessionItem('activeTabs', JSON.stringify(this.activeTabs))
				switch (this.activeTabs) {
					case 'baseInfo':
						this.getLibInfo()
						break
					case 'expertList':
						if (val == '1') {
							this.$nextTick(() => {
								this.$refs.expertList[0].getSpecialtyList()
								this.$refs.expertList[0].doSearch()
							})
						}
						break
					case 'belongUnit':
						this.getLibUnitList()
						break
					case 'majorType':
						this.getSpecialtyList()
						break
					case 'changeRecord':
						if (val == '1') {
							this.$nextTick(() => {
								this.$refs.changeRecord[0].getLibChanges()
							})
						}
						break
					default:
						break
				}
			}
		},
		//顶部tab页的保存按钮
		doSave() {
			this.btnLoading = true
			switch (this.activeTabs) {
				case 'baseInfo':
					this.saveBaseLibInfo()
					break
				case 'belongUnit':
					this.saveLibUnit()
					break
				case 'majorType':
					this.saveSpecialty()
				default:
					break
			}
		},
		//顶部tab页的修改按钮
		modify() {
			if (this.leftRowId == '') {
				this.$message.warning('请先创建应用库！')
				return
			}
			this.isEdit = true
		},
		/***** 选项卡一： 基础信息维护 *****/
		// 获取专家库基础信息
		getLibInfo() {
			API.getLibInfo({ id: this.leftRowId }).then((res) => {
				if (res.operationCode === 1) {
					this.baseForm = res.data
					this.baseForm.libApply = res.data.libApply.split(',')
				}
			})
		},
		// 专家库状态改变时
		changeStatus() {
			this.changeType = true
			let status = this.baseForm.status
			this.baseForm.status = this.baseForm.status == 0 ? 1 : 0
			let params = {
				libId: this.leftRowId,
				type: '3',
				status: status,
				createUser: this.userInfo.sname
			}
			API.changeStatus(params).then((res) => {
				if (res.operationCode == 1) {
					this.baseForm.status = status
					this.getLibList()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		//基础信息保存
		saveBaseLibInfo() {
			let params = Object.assign({}, this.baseForm)
			let applyName = this.baseForm.libApply.map((x) => {
				let arr = this.zjkyt.find((item) => {
					return item.value === x
				})
				return arr.sname
			})
			params.libApply = this.baseForm.libApply.join(',')
			params.applyName = applyName.join(',')
			params.createUser = this.userInfo.sname
			params.createUserid = this.userInfo.id
			if (params.openRemark == '') {
				this.$message.warning('库对外开放说明不能为空！')
				this.btnLoading = false
				return
			} else if (params.applyStandard == '') {
				this.$message.warning('入库标准不能为空！')
				this.btnLoading = false
				return
			} else {
				API.saveLibInfo(params)
					.then((res) => {
						if (res.operationCode == 1) {
							this.$message.success('保存成功！')
							this.getLibInfo()
							this.isEdit = false
							setTimeout(() => {
								this.btnLoading = false
							}, 2000)
						} else {
							this.$message.error(res.msg)
							setTimeout(() => {
								this.btnLoading = false
							}, 2000)
						}
					})
					.catch((err) => {
						setTimeout(() => {
							this.btnLoading = false
						}, 2000)
					})
			}
		},
		/***** 选项卡二： 专家列表 *****/

		// 获取专家库用途码表
		getDictsByReason() {
			API.getDictsByParent({ value: '1012' }).then((res) => {
				this.zjtyyy = res.data
			})
		},
		//跳转查看专家详情页面
		setId(data) {
			this.expertId = data.id
			this.$setSessionItem('searchObj', JSON.stringify(data.searchObj))
			this.$setSessionItem('activeTabs', JSON.stringify(this.activeTabs))
			this.$setSessionItem('leftRowId', JSON.stringify(this.leftRowId))
			this.$router.push({
				name: 'application-expert',
				query: {
					type: 'check'
				}
			})
		},
		//当专家库专家状态发生改变时
		handleChange(data) {
			this.dialogObj.title = data.status ? '停用专家库' : '启用专家库'
			this.dialogObj.width = '600px'
			this.dialogObj.module = 'changeState'
			this.dialogObj.visible = true
			this.$nextTick(() => {
				this.$refs.changeState.resetFields()

				this.changeForm.changeId = Snowflake.nextId()
				this.changeForm.userId = data.userId
				this.changeForm.status = data.status ? 0 : 1
				this.changeForm.libId = this.leftRowId
				this.changeForm.createUser = this.userInfo.sname
				this.getDictsByReason()
			})
		},
		// 改变专家库专家状态请求
		changeLibExpert(params) {
			this.$refs.changeState.validate((valid) => {
				if (valid) {
					API.changeStatus(params)
						.then((res) => {
							if (res.operationCode == 1) {
								this.$refs.expertList[0].doSearch(1)
								this.dialogObj.btnLoading = false
								this.dialogObj.visible = false
							} else {
								this.$message.error(res.msg)
								this.dialogObj.btnLoading = false
								this.dialogObj.visible = false
							}
						})
						.then((err) => {
							this.dialogObj.btnLoading = false
							this.dialogObj.visible = false
						})
				} else {
					this.dialogObj.btnLoading = false
				}
			})
		},
		/***** 选项卡三： 归属单位维护 *****/
		// 获取归属单位维护列表
		getLibUnitList() {
			API.getLibUnitList({ id: this.leftRowId }).then((res) => {
				if (res.operationCode == 1) {
					this.isOpen = res.data.isOpen
					this.belongUnit.tableData = res.data.gsList
					this.manageUnit.tableData = res.data.glList
					this.openUnit.tableData = res.data.kfList
				}
			})
		},
		//新增单位
		addUnit(type) {
			this.dialogObj.title = '选择单位'
			this.dialogObj.width = '1000px'
			this.dialogObj.module = 'select'
			this.dialogObj.type = type
			this.dialogObj.visible = true
			this.companyName = ''
			this.selectTable.tableData = []
			this.checkList = []
			this.choiseIds = this[type].tableData.map((item) => {
				return item.tenantId
			})
		},
		//精确查询归属单位
		getLibExpert() {
			if (this.companyName == '') {
				this.$message.warning('请输入你要查询的公司全称！')
				return
			}
			let params = {
				ids: this.choiseIds.join(','),
				sname: this.companyName
			}
			console.log(params)
			API.getTenantsForExpert(params).then((res) => {
				if (res.operationCode == 1) {
					if (res.data.length > 0) {
						//单位数组不为空
						this.$refs.selectTable.setCheckboxRow(res.data, true)
						if (this[this.dialogObj.type].tableData.length <= 10) {
							this.choiseIds.push(res.data[0].tenantId)
							this.selectTable.tableData.push(res.data[0])
							this.checkList.push(res.data[0])
						} else {
							this.$message.warning('每次最多提交十个单位！')
						}
					} else {
						this.$message.warning('暂无单位!')
					}
				}
			})
		},
		//当多选框发生改变时
		selectChangeEvent(val) {
			this.checkList = val.records
		},
		//选择单位时的删除图标
		deleteCompany(item, index) {
			this.$refs.selectTable.setCheckboxRow(item, false)
			this.checkList.splice(index, 1)
		},
		// 归属单位管理的删除按钮
		handleDelete(type, index) {
			this.$confirm('确认删除吗？', '删除', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
				// center: true
			})
				.then(() => {
					this[type].tableData.splice(index, 1)
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					})
				})
		},
		// 归属单位保存
		saveLibUnit() {
			let params = {
				createUser: this.userInfo.sname,
				gsList: this.belongUnit.tableData,
				glList: this.manageUnit.tableData,
				kfList: this.openUnit.tableData,
				libId: this.leftRowId,
				isOpen: this.isOpen
			}
			if (params.isOpen == '0' && params.kfList.length == 0) {
				this.$message.warning('请选择至少一个指定单位！')
				setTimeout(() => {
					this.btnLoading = false
				}, 2000)
				return
			}
			API.saveLibUnit(params)
				.then((res) => {
					if (res.operationCode == 1) {
						this.$message.success('保存成功！')
						this.getLibUnitList()
						this.isEdit = false
						setTimeout(() => {
							this.btnLoading = false
						}, 2000)
					} else {
						this.$message.error(res.msg)
						setTimeout(() => {
							this.btnLoading = false
						}, 2000)
					}
				})
				.catch((err) => {
					setTimeout(() => {
						this.btnLoading = false
					}, 2000)
				})
		},
		/***** 选项卡四： 专家专业类别 *****/
		// 查询专家专业类别
		getSpecialtyList() {
			API.getSpecialtyList({ libId: this.leftRowId }).then((res) => {
				if (res.operationCode == 1) {
					this.dataTree = res.data === null ? [] : res.data
				}
			})
		},
		handleSet(level) {
			this.dialogObj.type = 'add'
			if (level == '0') {
				this.majorForm.label1 = ''
			}
			this.dialogObj.title = '新增'
			this.dialogObj.module = 'major'
			this.dialogObj.width = '600px'
			this.majorForm.createUser = this.userInfo.sname
			this.showLevel = level
			this.dialogObj.visible = true
		},
		// 新增专家专业
		append(node, data) {
			if (!data.children) {
				this.$set(data, 'children', [])
			}
			this.currentData = data
			this.currentNode = Object.assign({}, node, true)
			this.majorForm = {
				label1: '', //一级标题
				label2: '', //二级标题
				label3: '', //三级标题
				label4: '', //四级标题
				createUser: '' //创建人
			}
			switch (node.level) {
				case 1:
					this.majorForm.label1 = node.data.sname
					break
				case 2:
					this.majorForm.label2 = node.data.sname
					this.majorForm.label1 = node.parent.data.sname
					break
				case 3:
					this.majorForm.label3 = node.data.sname
					this.majorForm.label2 = node.parent.data.sname
					this.majorForm.label1 = node.parent.parent.data.sname
					break
			}
			this.handleSet(node.level)
		},
		//修改专家专业
		edit(node, data) {
			this.dialogObj.type = 'edit'
			this.currentData = data
			this.currentNode = Object.assign({}, node, true)
			let level = Number(node.level) - 1
			switch (level) {
				case 0:
					this.majorForm.label1 = node.data.sname
					break
				case 1:
					this.majorForm.label2 = node.data.sname
					this.majorForm.label1 = node.parent.data.sname
					break
				case 2:
					this.majorForm.label3 = node.data.sname
					this.majorForm.label2 = node.parent.data.sname
					this.majorForm.label1 = node.parent.parent.data.sname
					break
				case 3:
					this.majorForm.label4 = node.data.sname
					this.majorForm.label3 = node.parent.data.sname
					this.majorForm.label2 = node.parent.parent.data.sname
					this.majorForm.label1 = node.parent.parent.parent.data.sname
					break
			}
			this.dialogObj.title = '编辑'
			this.dialogObj.module = 'major'
			this.dialogObj.width = '600px'
			this.majorForm.createUser = this.userInfo.sname
			this.showLevel = level
			this.dialogObj.visible = true
		},
		// 删除专家专业
		remove(node, data) {
			let that = this
			that.$confirm('确认删除吗?', '删除', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					let params = {
						id: data.id,
						libId: that.leftRowId
					}
					API.delSpecialty(params).then((res) => {
						if (res.operationCode == '1') {
							const parent = node.parent
							const children = parent.data.children || parent.data
							const index = children.findIndex((d) => d.id === data.id)
							children.splice(index, 1)
						} else {
							that.$message.error(res.msg)
						}
					})
				})
				.catch(() => {
					that.$message({
						type: 'info',
						message: '已取消删除'
					})
				})
		},
		//保存专家专业
		saveSpecialty() {
			let params = {
				createUser: this.userInfo.sname,
				libId: this.leftRowId,
				list: this.dataTree
			}
			API.saveSpecialty(params)
				.then((res) => {
					if (res.operationCode == '1') {
						this.$message.success('保存成功！')
						this.getSpecialtyList()
						this.isEdit = false
						setTimeout(() => {
							this.btnLoading = false
						}, 2000)
					} else {
						this.$message.error(res.msg)
						setTimeout(() => {
							this.btnLoading = false
						}, 2000)
					}
				})
				.catch((err) => {
					setTimeout(() => {
						this.btnLoading = false
					}, 2000)
				})
		}
	},
	computed: {
		// tab 选项卡
		tabArr() {
			return [
				{ label: '基础信息维护', name: 'baseInfo', iconClass: 'baseInfo' },
				{ label: '专家列表', name: 'expertList', iconClass: 'expertList' },
				{ label: '归属单位维护', name: 'belongUnit', iconClass: 'belongUnit' },
				{ label: '专家专业类别', name: 'majorType', iconClass: 'majorType' },
				{ label: '变更记录', name: 'changeRecord', iconClass: 'changeRecord' }
			]
		},
		...mapState('user', { userInfo: (state) => state.userInfo }),
		...mapState('app', { isBack: (state) => state.isBack }),
		routeQuery() {
			return this.$route.query.type
		}
	}
}
</script>
<style scoped lang="less">
.left {
	padding-top: 10px !important;
}

/deep/.w-split-layout .w-split-pane {
	overflow: auto !important;
}

.w-table-layout {
	// overflow: auto !important;
}

.tab-main {
	position: relative;
	height: 100%;

	.add-btns {
		position: absolute;
		right: 20px;
		z-index: 999;
		cursor: pointer;
		border-bottom: 2px solid #e4e7ed;
		padding-bottom: 5px;
	}
}

.tab-box {
	height: 100%;
	overflow-y: auto !important;
}

.el-form-item {
	margin-bottom: 10px !important;
}

/deep/.el-tabs__content {
	overflow: auto !important;
}

.expertBak {
	/deep/.editor .ql-container {
		height: 60px !important;
		min-height: 60px !important;
	}

	/deep/div.ql-editor {
		height: 60px !important;
		min-height: 60px !important;
	}
}

.expertOpenBak {
	/deep/.editor .ql-container {
		height: 80px !important;
		min-height: 80px !important;
	}

	/deep/div.ql-editor {
		height: 80px !important;
		min-height: 80px !important;
	}
}

.expertStandard {
	/deep/.editor .ql-container {
		height: 200px !important;
		min-height: 200px !important;
	}

	/deep/div.ql-editor {
		height: 200px !important;
		min-height: 200px !important;
	}
}

.belong_unit {
	padding: 0 20px 30px 0;
	border-bottom: 10px solid #f2f2f2;
}

.manage_unit {
	padding: 20px 20px 30px 0;
	border-bottom: 10px solid #f2f2f2;
}

.open_unit {
	padding: 20px 20px 30px 0;
}

.unit_label {
	float: left;
	font-size: 14px;

	span {
		color: red;
	}
}

.add_unit {
	float: right;
	margin-right: 40px;
}

.clean {
	clear: both;
}

.tree_header {
	width: 1200px;
	height: 46px;
	line-height: 46px;
	background-color: #f5f5f5;

	span {
		display: inline-block;
	}

	.name {
		width: 600px;
		padding-left: 40px;
	}

	.state,
	.operation {
		width: 300px;
		text-align: center;
	}
}

.major_name,
.major_operation {
	display: inline-block;
}

.major_name {
	width: 400px;
}

.major_operation {
	width: 600px;
	padding-left: 50px;

	.hide {
		opacity: 0;
	}

	span {
		margin: 0 10px;
	}

	.major_state {
		margin-right: 200px;
	}
}

.info-nav {
	.label {
		line-height: 32px;
	}
}

.custom-tree-node {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 14px;
	padding-right: 90px;
}

.major_header {
	font-size: 14px;

	span {
		color: red;
	}
}

.color-failed {
	color: red;
}

.belongLib {
	color: #9595ff;
	background: #eaeaff;
	border-radius: 20px;
}

.libType {
	color: #29abe2;
	background: #e4f5fe;
}

.checked-company {
	margin-top: 10px;

	span {
		margin-right: 15px;
		display: inline-block;

		.el-icon-success {
			color: #256ccb;
			margin-right: 8px;
		}

		.el-icon-circle-close {
			cursor: pointer;
			margin-left: 5px;
		}
	}
}

.w-page-main {
	overflow: auto !important;
}
</style>
